import React, { useState } from "react";
import { X } from "lucide-react";

const CancelReasonModal = ({ isOpen, onClose, onSubmit, isLoading, data }) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason) return;
    onSubmit({ reason: reason});
  };

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50 transition-opacity">
      <div className="mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl transition-all transform">
        <div className="flex justify-between items-center px-6 py-4">
          <h3 className="font-sans text-xl font-bold text-gray-900">
            Cancel Reserve Transaction
          </h3>

          <button
            onClick={onClose}
            className="text-gray-400 transition-colors hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="px-6 pb-3">

          <div className="">
            {/* <p className="mb-2 font-sans text-sm text-gray-500">
              Choose the number of days to extend the reserve for this transaction.
            </p> */}
            
            <div className="p-2 mb-3 bg-gray-100 rounded-lg">
              <p className="font-sans text-sm text-gray-500">
                Reference: <span className="font-semibold">{data?.reference}</span>
              </p>

              <p className="font-sans text-sm text-gray-500">
                Name: <span className="font-semibold capitalize">{data?.user?.firstName || ""} {data?.user?.lastName || ""}</span>
              </p>
            </div>
          </div>


          <div className="mb-6">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Reason for Reserve Cancellation
            </label>
            <input
              type="text"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="px-4 py-3 w-full text-base rounded-xl border border-gray-300 transition-all outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400"
              placeholder="e.g. Reason for cancellation"
              required
            />
          </div>

          <div className="flex gap-3 justify-end items-center">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 text-sm font-bold text-gray-700 bg-white rounded-xl border-2 border-gray-200 transition-all hover:bg-gray-50 active:scale-95"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading || !reason}
              className={`px-5 py-2.5 text-sm font-bold text-white bg-red-600 rounded-xl transition-all active:scale-95 ${isLoading || !reason ? "opacity-50 cursor-not-allowed" : "hover:bg-red-700"
                }`}
            >
              {isLoading ? "Loading..." : "Cancel Reserve"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelReasonModal;
